// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TableTxsInfinite-module__infiniteScroll___ZyM3j{display:grid;grid-gap:15px;gap:15px}", "",{"version":3,"sources":["webpack://./src/components/TableTxsInfinite/TableTxsInfinite.module.scss"],"names":[],"mappings":"AAAA,iDACE,YAAA,CACA,aAAA,CAAA,QAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infiniteScroll": "TableTxsInfinite-module__infiniteScroll___ZyM3j"
};
export default ___CSS_LOADER_EXPORT___;
